"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyScope = void 0;

var _constants = require("../constants");

var verifyScope = function verifyScope(_ref) {
  var action = _ref.action,
      userScopes = _ref.userScopes,
      _ref$matchAny = _ref.matchAny,
      matchAny = _ref$matchAny === void 0 ? false : _ref$matchAny;
  var requiredScopes = _constants.scopeMappings[action].requiredScopes; // if matchAny flag is true, checks if even one of the requiredScopes is present

  if (matchAny) return requiredScopes.some(function (scope) {
    return userScopes.includes(scope);
  });
  return requiredScopes.every(function (scope) {
    return userScopes.includes(scope);
  });
};

exports.verifyScope = verifyScope;